<script setup lang="ts">
import { computed } from 'vue';
import {
  STATUS_BADGE_CLASS,
  type ShipmentDisplayStatus,
} from '@/utils/shipment-status-ui';

const props = defineProps<{
  status: ShipmentDisplayStatus | string;
}>();

const badgeClass = computed(() => {
  const status = props.status as ShipmentDisplayStatus;
  return STATUS_BADGE_CLASS[status] ?? STATUS_BADGE_CLASS.Draft;
});
</script>

<template>
  <span
    class="inline-block whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold leading-none"
    :class="badgeClass"
  >
    {{ status }}
  </span>
</template>
